<template>
  <section class="w-100">
    <div v-for="(fieldConfig, i) in fieldConfigs" :key="fieldConfig.name">
      <component
        :is="fieldConfig.component"
        :value="formData[fieldConfig.name] || ''"
        :classes="i < fieldConfigs.length - 1 ? 'mb-4' : ''"
        :rules="getFieldRules(fieldConfig)"
        v-bind="fieldConfig"
        @input="onFieldInput(fieldConfig, $event)"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SectionDynamicFields',
  data: vm => ({
    rules: {
      email: [v => /.+@.+\..+/.test(v) || vm.$t('action.fields.email.validation.valid', vm.locale)],
      phone: [
        v =>
          vm.formData.user_sms_opt_in === 'YES'
            ? !!v || vm.$t('action.fields.phone.validation.smsConsentMissingPhone', vm.locale)
            : true
      ]
    }
  }),
  computed: {
    ...mapState('actionForm', ['formData', 'locale']),
    ...mapGetters('actionForm', ['fieldConfigs'])
  },
  methods: {
    onFieldInput(fieldConfig, value) {
      this.$store.commit('actionForm/UPDATE_FORM_DATA_FIELD_VALUES', {
        fieldConfig,
        value
      })
    },
    getFieldRules(fieldConfig) {
      let rules = []
      // If field is marked as required add the validation rule
      if (fieldConfig.required) {
        rules.push(v => !!v || this.$t('action.fields.generic.validation.required', this.locale))
      }
      // If data.rules contains extra validation rules for this field, add them too
      if (this.rules[fieldConfig.name]) {
        rules = rules.concat(this.rules[fieldConfig.name])
      }
      return rules
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_panels-common.scss';
</style>
